import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface InstituteBranding {
  primaryColor?: string;   // Hex color, e.g. "#8A70D6"
  logoUrl?: string;        // URL to school logo
  schoolName?: string;     // Display name for white-labeling
}

interface InstituteState {
    instituteId: number;
    branding: InstituteBranding;
    setInstitute: (instituteId: number) => void;
    setBranding: (branding: Partial<InstituteBranding>) => void;
}

export const useInstituteStore = create<InstituteState>()(
    persist(
        (set) => ({
            instituteId: 0,
            branding: {},
            setInstitute: (instituteId: number) => {
                set({ instituteId });
            },
            setBranding: (branding: Partial<InstituteBranding>) => {
                set((state) => ({ branding: { ...state.branding, ...branding } }));
            },
        }),
        {
            name: 'institute',
        }
    )
);